<template>
  <div class="icon">
    <avatar-icon class="user-icon" :user="user" />
  </div>
  <h2 class="user-header">
    {{ testState ? TestStateUser.displayName : user?.displayName }}
  </h2>
  <h4 class="user-subtitle">
    {{ testState ? TestStateUser.email : user?.email }}
  </h4>
  <heading-chip />
</template>

<script setup>
import { watch, computed, ref } from 'vue';
import { AvatarIcon, useAuthentication } from 'ihunter-pathfinder-components';
import { useTestState } from '../composables/useTestState';
import HeadingChip from './HeadingChip.vue';

const { TestStateUser, testState } = useTestState();
const { user } = useAuthentication();

</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Header' as Header;

div {
  @include Header.Style;
}
</style>